function svgToURI(svg) {
  return "\'data:image/svg+xml;utf8," + encodeURIComponent(svg) + "\'";
}

export default svgToURI;
